import React, { useEffect, useState } from 'react'
import InlinePreloader from '../../elements/InlinePreloader';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';    
import ModalActionButton from '../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStaff } from '../../../store/actions/staffActions';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import TextField from '../../elements/form/TextField';
import { clearCreatedDepartment, updateDepartment } from '../../../store/actions/departmentActions';
import TextareaField from '../../elements/form/TextareaField';
import RadioGroup from '../../elements/form/RadioGroup';

const EditDepartment = ({department, closeFunction, reload}) => {
    const dispatch = useDispatch()
    const departmentsSelector = useSelector(state => state.departments)
    const staffSelector = useSelector(state => state.staff)

    const [departmentPayload, setDepartmentPayload] = useState(department || {});
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        dispatch(fetchStaff(`department=${department._id}`, 0, 0))
        if(departmentsSelector.createdDepartment !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'New department created successfully!'
            })
            dispatch(clearCreatedDepartment())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departmentsSelector.createdDepartment, dispatch, closeFunction]);

    const validateForm = () => {
        let errors = {}
        if(!departmentPayload.name || departmentPayload.name === '') {
            errors.name = true
        }
        if(!departmentPayload.type || departmentPayload.type === '') {
            errors.type = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushDepartment = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(updateDepartment(department._id, departmentPayload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    const departmentTypes = [
        {
            label: 'Academic',
            value: 'academic'
        },
        {
            label: 'Non-academic',
            value: 'non-academic'
        },
    ]

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>Provide the following information to create a new academic session</p>
            </div>
            <div className='mt-4'>
                <TextField
                    inputLabel="Department name" 
                    fieldId="fee-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={departmentPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setDepartmentPayload({...departmentPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="status-note" 
                    inputType="text" 
                    requiredField={false}
                    preloadValue={departmentPayload.description || ''}
                    hasError={false} 
                    maxLength={300}
                    inputPlaceholder={'Provide a brief description of the department'}
                    returnFieldValue={(value)=>{setDepartmentPayload({...departmentPayload, ...{description: value}})}}
                />
                {departmentPayload?.description?.length === 300 &&<p className='text-red-600 text-xs mt-2'>Please keep the description less than 300 characters</p>}
            </div>

            <div className='mt-4'>
                <RadioGroup 
                    items={departmentTypes} 
                    inline={true}
                    preSelectedIndex={departmentTypes.findIndex(item => item.value === departmentPayload.type)}
                    inputLabel={'Department Type'}
                    requiredField={true}
                    returnSelected={(value) => {setDepartmentPayload({...departmentPayload, ...{type: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>

            {staffSelector?.loadingStaff 
            ? 
            <div className="flex items-center justify-center w-full h-[200px]">
                <InlinePreloader />
            </div>
            : 
              <>
                {staffSelector?.staffMembers?.staff?.length > 0 && <div className='mt-4 relative'>
                  <AutocompleteSelect
                    selectOptions = {staffSelector?.staffMembers?.staff}
                    inputLabel = "Head of Department"
                    requiredField={true}
                    titleField = "fullName"
                    displayImage = {false}
                    imageField = ""
                    placeholderText={`Select a member of staff`}
                    fieldId = {`class-parent`}
                    preSelected={departmentPayload?.hod?._id || ''}
                    preSelectedLabel='_id'
                    hasError = {validationErrors && validationErrors.hod}
                    returnFieldValue={(value)=>{setDepartmentPayload({...departmentPayload, ...{hod: value._id}})}}
                  />
                </div>}
                
                {staffSelector?.staffMembers?.staff?.length === 0 && 
                  <div className='w-full mt-[20px] p-[15px] bg-gray-50 border border-gray-400 rounded-[8px] bg-opacity-'>
                    <h3 className='text-sm text-gray-600 font-[500] tracking-tight'>No staff found for this department</h3>
                    <p className='text-xs font-[500] text-gray-600'>Please assign some staff to this department first before you can select one as a Head of Department</p>
                  </div>
                }
              </>
            }

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update department`}
                    buttonAction={()=>{pushDepartment()}}
                    processing={departmentsSelector.creatingDepartment}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default EditDepartment